import React from 'react';
import {
  VideoIcon,
  CalendarIcon,
  ShieldCheckIcon,
  GlobeIcon,
  MessageCircleIcon,
  AwardIcon,
  ClockIcon,
  ZapIcon,
  QuoteIcon,
} from '../../../components/common/IconsComponent';

const features = [
  {
    title: 'Live Interactive Classes',
    description: 'Engage in real-time with teachers through HD video conferencing with screen sharing and whiteboard features.',
    icon: VideoIcon,
    iconWrap: 'bg-blue-100',
    iconColor: 'text-blue-600',
  },
  {
    title: 'Flexible Scheduling',
    description: 'Book lessons at your convenience with our smart scheduling system that adapts to your timezone.',
    icon: CalendarIcon,
    iconWrap: 'bg-emerald-100',
    iconColor: 'text-emerald-600',
  },
  {
    title: 'Verified Teachers',
    description: 'All our teachers go through a rigorous verification process to ensure quality education.',
    icon: ShieldCheckIcon,
    iconWrap: 'bg-purple-100',
    iconColor: 'text-purple-600',
  },
  {
    title: 'Multi-Language Support',
    description: 'Learn in English, Arabic, or Hebrew with teachers from around the world.',
    icon: GlobeIcon,
    iconWrap: 'bg-orange-100',
    iconColor: 'text-orange-600',
  },
  {
    title: 'Direct Communication',
    description: 'Message your teachers directly for questions, feedback, and personalized guidance.',
    icon: MessageCircleIcon,
    iconWrap: 'bg-pink-100',
    iconColor: 'text-pink-600',
  },
  {
    title: 'Certificates',
    description: 'Earn certificates upon course completion to showcase your achievements.',
    icon: AwardIcon,
    iconWrap: 'bg-yellow-100',
    iconColor: 'text-yellow-600',
  },
  {
    title: 'Recorded Sessions',
    description: 'Access recorded lessons anytime to review and reinforce your learning.',
    icon: ClockIcon,
    iconWrap: 'bg-teal-100',
    iconColor: 'text-teal-600',
  },
  {
    title: 'Instant Booking',
    description: 'Book and start learning within minutes with our seamless enrollment process.',
    icon: ZapIcon,
    iconWrap: 'bg-rose-100',
    iconColor: 'text-rose-600',
  },
];

const FeatureCard = ({ title, description, icon: Icon, iconWrap, iconColor }) => (
  <div className="flex flex-col rounded-2xl bg-white p-5 shadow-sm ring-1 ring-gray-100 transition duration-300 hover:-translate-y-1 hover:shadow-md sm:p-6">
    <div className="mb-4 flex items-center justify-between">
      <div
        className={`flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-xl sm:h-14 sm:w-14 sm:rounded-2xl ${iconWrap}`}
      >
        <Icon className={`h-6 w-6 sm:h-7 sm:w-7 ${iconColor}`} aria-hidden="true" />
      </div>

      <QuoteIcon
        className="h-8 w-8 flex-shrink-0 text-indigo-200 sm:h-9 sm:w-9"
        aria-hidden="true"
      />
    </div>

    <h3 className="mb-2 text-base font-semibold text-slate-900 sm:text-lg">
      {title}
    </h3>

    <p className="text-sm leading-relaxed text-slate-500 sm:text-base sm:leading-7">
      {description}
    </p>
  </div>
);

const WhyChooseDoroos = () => (
  <section className="bg-gray-50 py-12 lg:py-20" dir='ltr'>
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">

      {/* Header */}
      <div className="mb-10 text-center sm:mb-12">
        <h2 className="text-2xl font-bold tracking-tight text-slate-900 sm:text-4xl lg:text-5xl">
          Why Choose DoroosOnline?
        </h2>
        <p className="mx-auto mt-3 max-w-2xl text-base text-slate-500 sm:mt-4 sm:text-lg">
          Experience the future of online education with features designed for your success
        </p>
      </div>

      {/* Grid */}
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 sm:gap-5 xl:grid-cols-4">
        {features.map((feature) => (
          <FeatureCard key={feature.title} {...feature} />
        ))}
      </div>

    </div>
  </section>
);

export default WhyChooseDoroos;